// Chart.js
$('.chart-doughnut').each(function() {
    var ctx = $(this).get(0);
    var dataValue = $(this).data('value');
    var dataEmpty = 100 - dataValue;

    if ($(this).data('color')) {
        var dataColor = $(this).data('color');
    } else {
        var dataColor = '#8FFF74';
    }

    var chart = new Chart(ctx, {
        type: 'doughnut',
        data: {
            datasets: [
                {
                    data: [dataValue, dataEmpty],
                    backgroundColor: [dataColor, 'rgba(150,150,150,.2)'],
                    borderWidth: 0,
                }
            ]
        },
        options: {
            cutoutPercentage: '92',
            aspectRatio: 1,
            legend: {
                display: false
            },
            plugins: {
                legend: {
                    display: false,
                }
            },
            tooltips: {
                enabled: false
            }
        }
    });
});

// CSS Charts
// Charts
$('.chart-horizontal').each(function() {
    var chart = $(this);
    var barFill = chart.data('value');
    chart
        .siblings('.chart-overlay')
        .css('left', barFill + '%');
    setTimeout(function() {
        chart
            .find('.chart-horizontal-fill')
            .css('width', barFill + '%');
    }, 300);
});
